const errorMessages = {
  statusNotFoundError: 'StatusNotFoundError',
  somethingWentWrong: 'SomethingWentWrong',
  sessionNotFoundError: 'SessionNotFoundError',
  insufficientFundsError: 'InsufficientFundsError',
  userNotFoundError: 'UserNotFoundError',
  unkownOperatorError: 'UnkownOperatorError',
  invalidCurrencyError: 'InvalidCurrencyError',
  duplicateTransactionIDError: 'DuplicateTransactionIdError',
  debitTransactionNotFoundError: 'DebitTransactionNotFoundError',
  invalidAmountError: 'InvalidAmountError',
  requestInputValidationError: 'RequestInputValidationError',
  responseValidationError: 'ResponseInputValidationError',
  socketRequestInputValidationError: 'SocketRequestInputValidationError',
  socketResponseValidationError: 'SocketResponseValidationError',
  internalServerError: 'InternalServerError',
  invalidSocketArgumentError: 'InvalidSocketArgumentError',
  invalidCredentials: 'InvalidCredentials',
  invalidToken: 'InvalidToken',
  operatorPlayerUnAuthenticated: 'OperatorPlayerUnAuthenticated',
  invalidGameTypeError: 'InvalidGameTypeError',
  invalidGameRoundError: 'InvalidGameRoundError',
  noRoundRunningError: 'NoRoundRunningError',
  noPlacedBetFoundError: 'NoPlacedBetFoundError',
  noUserFoundError: 'NoUserFoundError',
  notEnoughBalanceError: 'NotEnoughBalanceError',
  autoRateIsInvalidError: 'AutoRateIsInvalidError',
  betAmountIsNotInLimitError: 'BetAmountIsNotInLimitError',
  userNotAbove18YearsError: 'UserNotAbove18YearsError',
  invalidCredentialError: 'InvalidCredentialError',
  invalidTransactionError: 'InvalidTransactionError',
  blockedTransactionError: 'BlockedTransactionError',
  invalidOperatorIdError: 'InvalidOperatorIdError',
  betLimitReachedError: 'BetLimitReachedError',
  lossLimitReachedError: 'LossLimitReachedError',
  profitLimitReachedError: 'ProfitLimitReachedError',
  invalidSignature: 'InvalidSignature',
  invalidDebitOperatorResponse: 'InvalidDebitOperatorResponse',
  gameNotActive: 'GameNotActive',
  minAutoRateNotAchieved: 'MinAutoRateNotAchieved',
  crossGameTileAlreadyOpenedError: 'CrossGameTileAlreadyOpenedError',
  crossGameNoOpenedTileFoundError: 'CrossGameNoOpenedTileFoundError',
  invalidTileError: 'InvalidTileError',
  invalidLaneError: 'InvalidLaneError',
  crossGameAutoBetNotCompletedError: 'CrossGameAutoBetNotCompletedError',
  invalidDifficultyLevelError: 'InvalidDifficultyLevelError',
  crossGamePreviousRoundNotCompletedError: 'CrossGamePreviousRoundNotCompletedError',
  tryAgainError: 'TryAgainError',
  invalidSessionError: 'InvalidSessionError',
  invalidSegmentsError: 'InvalidSegmentsError',
  invalidRiskLevelError: 'InvalidRiskLevelError',
  invalidGameIdError: 'InvalidGameIdError',
  invalidRoundError: 'InvalidRoundError',
  roundAlreadyFinishedError: 'RoundAlreadyFinishedError',
  placeBetCanNotBeenCanceledError: 'PlaceBetCanNotBeenCanceledError',
  autoBetNotCompletedError: 'AutoBetNotCompletedError',
  tileAlreadyOpenedError: 'TileAlreadyOpenedError',
  invalidTargetMultiplierError: 'InvalidTargetMultiplierError',
  initialCardRangeError: 'InitialCardRangeError'
}

export default errorMessages
